import { UserFilterType } from '../../apps/professional-app/fa/common/userFilter/hooks'

export enum FilterOperator {
  GT = '>',
  LT = '<',
  EQUALS = '=',
  NOT_EQUALS = '!=',
  GTE = '>=',
  LTE = '<=',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}

export enum OperatorType {
  AND = 'and',
  OR = 'or',
}

export enum FilterAttribute {
  SOURCE_TYPE = 'source_type',
  MEETING_TYPE = 'meeting_type',
  BOT_SENT = 'bot_sent',
  ASSISTANT_JOINED = 'assistant_joined',
  USER_ID = 'user_id',
  CONTACT_ID = 'contact_id',
  PROCESSED = 'processed',
  ZOCKS_ANALYZED = 'zocks_analyzed',
  KIND = 'kind',
  STARTED = 'started_at',
  FINISHED = 'finished_at',
}

export type SessionSort = {
  attr: FilterAttribute
  dir: 'asc' | 'desc'
}

export type SessionFilter = IndividualSessionFilter | CompositeSessionFilter
export interface IndividualSessionFilterValue {
  op: FilterOperator
  attr: FilterAttribute
  val: string | boolean | null
}

export interface IndividualSessionFilter {
  type: 'individual'
  filter: IndividualSessionFilterValue
}

export interface CompositeSessionFilter {
  type: 'composite'
  filters: SessionFilter[]
  operator: OperatorType
}

export interface SessionFilterViewProps {
  filterType: UserFilterType
  disabled?: boolean
  onFilterChanged?: (searchParam: URLSearchParams) => void
}

export interface SessionQuickFilter {
  id: string
  name: string
  filter: SessionFilter
  isDefault: boolean
  type: string
}
